<template>
    <div>
        <div class="basket-col col-delivery">
            <div class="basket-group">
                <div class="basket-group-title">{{phrases.BASKET_USER_NAME}}</div>
                <div class="basket-group-field">
                    <input v-model="deliveryUserName" class="basket-group-input size-lg" type="text" :placeholder="phrases.BASKET_USER_NAME">
                </div>
            </div>
            <div class="basket-group">
                <div class="basket-group-title">{{phrases.TEXT_PHONE_NUMBER}}</div>
                <div class="basket-group-field">
                    <div class="basket-group-input size-lg disabled" type="text">{{userInfo.phone}}</div>
                </div>
            </div>
            <div class="basket-group">
                <div class="basket-group-title">{{phrases.BASKET_DELIVERY_TYPE}}</div>
                <div class="basket-group-buttons">
                    <div class="basket-group-button" :class="{ active: isDelivery}" @click="changeDeliveryType(true)"
                         data-action="" data-name="delivery-type" data-value="delivery">{{phrases.BASKET_DELIVERY_TYPE__DELIVERY}}
                    </div>
                    <div class="basket-group-button" :class="{ active: !isDelivery}" @click="changeDeliveryType(false)"
                         data-name="delivery-type" data-value="pickup">{{phrases.BASKET_DELIVERY_TYPE__PICKUP}}
                    </div>
                </div>
            </div>
            <div class="basket-group" v-if="isDelivery">
                <div class="basket-group-title">{{phrases.BASKET_DELIVERY_TIME_TYPE}}</div>
                <div class="basket-group-buttons vertical">
                    <div v-if="!isPizzeriaClosed && isAvailableClosestDelivery" class="basket-group-button"
                         :class="{ active: !isDeferOrder}" @click="changeOrderType(false)">
                        {{phrases.BASKET_DELIVERY_TIME_TYPE__NEAREST}}
                    </div>
                    <div class="basket-group-button button-select-order-datetime"
                         :class="{ active: isDeferOrder}" @click="changeOrderType(true)">
                        {{phrases.BASKET_DELIVERY_TIME_TYPE__PENDING}}
                        <div class="delivery-date-controller" v-show="isDeferOrder">
                            <div class="calendar-icon"></div>
                            <calendar-view
                                :key="'calendar-delivery'"
                                :min-date="calendarDates.min"
                                :max-date="calendarDates.max"
                                :placeholder="phrases.BASKET_PREORDER_DATE_FIELD_PLACEHOLDER"
                                :first-day-of-week="1" :date="{year: new Date().getFullYear(), month: new Date().getMonth()}"
                                :pizzeria-schedule="this.preOrderSchedule"
                                :is-delivery="this.isDelivery"
                                @approveOrderDateTime="setOrderDateTime"
                                :phrases="phrases"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="basket-group" v-if="!isDelivery">
                <div class="basket-group-title">{{phrases.BASKET_PICKUP_TIME_TYPE}}</div>
                <div class="basket-group-buttons vertical">
                    <div v-if="!isPizzeriaClosed && isAvailableClosestPickup" class="basket-group-button"
                         :class="{ active: !isDeferOrder}" @click="changeOrderType(false)">
                        {{phrases.BASKET_PICKUP_TIME_TYPE__NEAREST}}
                    </div>
                    <div class="basket-group-button button-select-order-datetime"
                         :class="{ active: isDeferOrder}" @click="changeOrderType(true)">
                        {{phrases.BASKET_PICKUP_TIME_TYPE__PENDING}}
                        <div class="delivery-date-controller" v-show="isDeferOrder">
                            <div class="calendar-icon"></div>
                            <calendar-view
                                :key="'calendar-pickup'"
                                :min-date="calendarDates.min"
                                :max-date="calendarDates.max"
                                :placeholder="phrases.BASKET_PREORDER_DATE_FIELD_PLACEHOLDER"
                                :first-day-of-week="1" :date="{year: new Date().getFullYear(), month: new Date().getMonth()}"
                                :pizzeria-schedule="this.preOrderSchedule"
                                :is-delivery="this.isDelivery"
                                @approveOrderDateTime="setOrderDateTime"
                                :phrases="phrases"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="basket-group" v-if="!isDelivery">
                <div class="basket-group-title">{{phrases.TEXT_PIZZERIA}}</div>
                <div class="basket-group-buttons vertical">
                    <div class="basket-group-button" v-for="(point, index) in pizzeria.points"
                         :class="{active: activePizzeriaPointId === point.id, disable: isClosePizzeriaPointForPickup(point.id)}" :key="index"
                         @click="setPizzeriaPointId(point.id)">{{point.title}}</div>
                </div>
                <div class="basket-group-description warning" v-if="isClosePizzeriaPointForPickupBase(activePizzeriaPointId)">
                  {{ phrases.TEXT_CLOSE_PIZZERIA_POINT_NOTE }}
                </div>
            </div>
            <div class="basket-group" v-if="isDelivery">
                <div class="basket-group-title">{{phrases.TEXT_CITY}}</div>
                <div class="basket-group-field">
                    <div class="basket-group-input size-lg disabled" type="text">{{ pizzeria.title }}</div>
                </div>
            </div>
            <div class="basket-group" v-if="isDelivery && userInfo.addresses.length">
              <div class="basket-group-title">{{phrases.TEXT_CHOOSE_ADDRESS}}</div>
              <div class="basket-group-field">
                <select class="basket-group-select" @change="chooseSavedAddress(saved_address_id)" v-model="saved_address_id">
                  <option value="null">Добавить новый</option>
                  <option v-for="(address, index) in userAddresses(userInfo.addresses, cityCode)" :key="index" :value="address.id">{{ address.title }}</option>
                </select>
              </div>
            </div>
            <div class="basket-groups" v-if="isDelivery">
                <div class="basket-group">
                    <div class="basket-group-title">{{phrases.TEXT_STREET}}</div>
                    <div class="basket-group-field group-street">
                        <input class="basket-group-input" autocomplete="off" type="text" name="address[street]"
                               @keyup="searchStreet" v-model="street" v-if="startStreetSearch" ref="street"
                               @blur="leaveSearchStreetControl()">
                        <div class="basket-group-input street" :class="{'field-error': getFieldErrorState(requiredFields.street)}"
                             @click="startSearch()" v-if="!startStreetSearch">{{street}}</div>
                        <div class="error-popup" v-if="!found_streets.length && finding" v-html="phrases.TEXT_ADDRESS_IS_NOT_INCLUDED"></div>
                        <div class="dropdown-list" v-if="found_streets.length && finding">
                            <div class="dropdown-list-item" v-for="(street, index) in found_streets" :key="index"
                                 @click="selectStreet(street)">{{street.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="basket-groups" v-if="isDelivery">
                <div class="basket-group size-sm">
                    <div class="basket-group-title">{{phrases.TEXT_HOUSE}}</div>
                    <div class="basket-group-field">
                      <input ref="house" @keyup="checkHouseField()" class="basket-group-input" type="text" name="address[house]"
                             v-model="deliveryAddress.house"
                             :class="{'field-error': getFieldErrorState('house')}">
                    </div>
                </div>
              <div class="basket-group size-sm">
                    <div class="basket-group-title">{{phrases.TEXT_BUILDING}}</div>
                    <div class="basket-group-field">
                      <input ref="building" class="basket-group-input" type="text" name="address[building]"
                             v-model="deliveryAddress.building"
                             :class="{'field-error': getFieldErrorState('building')}">
                    </div>
                </div>
                <div class="basket-group size-sm">
                    <div class="basket-group-title size-sm">{{phrases.TEXT_ENTRANCE}}</div>
                    <div class="basket-group-field">
                        <input class="basket-group-input" type="text" name="address[entrance]"
                               v-model="deliveryAddress.entrance" :class="{'field-error': getFieldErrorState('entrance')}">
                    </div>
                </div>
            </div>
            <div class="basket-groups" v-if="isDelivery">
                <div class="basket-group size-sm">
                    <div class="basket-group-title size-sm">{{phrases.TEXT_FLOOR}}</div>
                    <div class="basket-group-field">
                        <input class="basket-group-input" type="text" name="address[floor]"
                               v-model="deliveryAddress.floor" :class="{'field-error': getFieldErrorState('floor')}">
                    </div>
                </div>
                <div class="basket-group size-sm">
                    <div class="basket-group-title size-sm">{{phrases.TEXT_OFF_APT}}</div>
                    <div class="basket-group-field">
                        <input class="basket-group-input" type="text" name="address[flat]"
                               v-model="deliveryAddress.flat" :class="{'field-error': getFieldErrorState('flat')}">
                    </div>
                </div>
                <div class="basket-group size-sm">
                    <div class="basket-group-title size-sm">{{phrases.TEXT_ENTRANCE_CODE}}</div>
                    <div class="basket-group-field">
                        <input class="basket-group-input" type="text" name="address[doorphone]"
                               v-model="deliveryAddress.doorphone" :class="{'field-error': getFieldErrorState('doorphone')}">
                    </div>
                </div>
            </div>
            <div class="basket-group" v-if="isDelivery">
                <div class="switcher">
                    <div class="switcher-title">{{phrases.TEXT_REMEMBER_ADDRESS}}</div>
                    <input id="skip-address" name="skip-address" value="1" type="checkbox" :checked="saveAddress" @click="changeSaveAddress">
                    <label class="switcher-toggle" for="skip-address"></label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Utils from "../Utils";
    import Checkout from "./Checkout";
    import CalendarView from "@/libs/calendar/CalendarView.vue";

    export default {
        name: "Delivery",
        components: {CalendarView},
        data: function(){
            return {
                found_streets: [],
                streets: [],
                street: null,
                finding: false,
                deliveryAddress: {
                    street: this.defaultStreet(),
                    house: '',
                    building: '',
                    floor: '',
                    flat: '',
                    entrance: '',
                    doorphone: '',
                },
                saved_address_id: null,
                startStreetSearch: false
            };
        },
        watch:{
            deliveryAddress: {
                handler: function(address) {
                    const newAddress = Object.assign({}, address);
                    this.$store.dispatch({
                        type: 'order/setDeliveryAddress',
                        deliveryAddress: newAddress,
                    });
                },
                deep: true,
            },
            deferOrderDate: {
                handler: function() {
                    this.calculateDiscount();
                },
                deep: true
            },
            isDeferOrder: {
              handler: function(value, oldValue) {
                const component = this;
                if(oldValue && !component.isDelivery){
                  if(component.isClosePizzeriaPoint(component.activePizzeriaPointId)){
                    const availablePoints = component.pizzeria.points.filter(p => {return p.id !== component.activePizzeriaPointId; });
                    component.$store.commit('order/setPizzeriaPointId', availablePoints[0].id);
                  }
                }
              },
              deep: true
            }
        },
        computed: {
            deliveryUserName: {
                get () {
                    if(this.$store.state.order.user.name !== null &&
                        !this.$store.state.order.user.name.length){
                        return this.$store.state.user.info.name;
                    }else{
                        return this.$store.state.order.user.name;
                    }
                },
                set (name) {
                    this.$store.dispatch({
                        type: 'order/setUserInfo',
                        user: {name: name},
                    });
                },
            },
            ...mapGetters('order', {
                isDelivery: 'isDelivery',
                isDeferOrder: 'isDeferOrder',
                saveAddress: 'getSaveAddress',
                activePizzeriaPointId: 'getPizzeriaPointId',
                defferOrderDate: 'getDeferOrderDate',
                defferOrderTime: 'deferOrderTime',
            }),
            ...mapGetters('user', {
                userBonuses: 'getBonuses',
                isUserAuthorize: 'isAuthorize',
                userInfo: 'getInfo',
            }),
            ...mapGetters('app', {
                pizzeria: 'getPizzeriaInfo',
                phrases: 'getPhrases'
            }),
            fullyCloseOrderTypeOnPizzeria: function (){
              return this.fullyCloseOrderType && this.pizzeria.hand_close.fully_closed;
            },
            fullyCloseDeliveryOrderType: function (){
              return this.closeDeliveryOrderType && this.pizzeria.hand_close.fully_closed;
            },
            fullyClosePickupOrderType: function (){
              return this.closePickupOrderType && this.pizzeria.hand_close.fully_closed;
            },
            isAvailableClosestDelivery: function (){
              if(this.fullyCloseOrderTypeOnPizzeria || this.fullyCloseDeliveryOrderType){
                return false;
              }
              return true;
            },
            isAvailableClosestPickup: function (){
              if(this.fullyCloseOrderTypeOnPizzeria || this.fullyClosePickupOrderType ||
                  (this.isDeferOrder && this.isClosePizzeriaPointForPickupBase(this.activePizzeriaPointId))){
                return false;
              }
              return true;
            },
            calendarDates: function (){
                const dates = Object.keys(this.preOrderSchedule);
                const minDate = this.getFirstDelayOrderDay(dates);
                const maxDate = dates[dates.length - 1];

                const min = {year: parseInt(minDate.slice(0, 4)), month: parseInt(minDate.slice(4, 6)) - 1, day: parseInt(minDate.slice(6))};
                const max = {year: parseInt(maxDate.slice(0, 4)), month: parseInt(maxDate.slice(4, 6)) - 1, day: parseInt(maxDate.slice(6))};

                return {min: min, max: max};
            }
        },
        methods:{
            changeDeliveryType(isDelivery){
                const component = this;
                if(isDelivery === component.isDelivery){
                  return;
                }
                component.$store.commit('order/setDeferOrderDate', null);
                component.$store.commit('order/setDeferOrderTime', null);
                component.declineOrderWithIncreaseTime();
                this.$store.dispatch({
                    type: 'order/changeDeliveryType',
                    isDelivery: isDelivery,
                }).then(function () {
                  if(component.activePizzeriaPointId === null){
                    component.$store.commit('order/setPizzeriaPointId', component.pizzeria.points[0].id);
                  }
                  component.afterChangeDeliveryType(isDelivery);
                });
            },
            setPizzeriaPointId(pizzeriaPointId){
                if(this.isClosePizzeriaPointForPickup(pizzeriaPointId)){
                  return;
                }
                this.$store.commit('order/setPizzeriaPointId', pizzeriaPointId);
            },
            afterChangeDeliveryType: function (isDelivery){
              const component = this;
              if(!component.isAvailableClosestDelivery || !component.isAvailableClosestPickup){
                if (isDelivery) {
                  if (!component.isAvailableClosestDelivery && component.isDelivery) {
                    this.changeOrderType(true);
                  } else {
                    component.calculateDiscount();
                  }
                } else {
                  if (!component.isAvailableClosestPickup && !component.isDelivery) {
                    this.changeOrderType(true);
                  } else {
                    component.calculateDiscount();
                  }
                }
              }else{
                component.calculateDiscount();
              }
            },
            changeOrderType(isDefer){
                const component = this;
                if(isDefer === component.isDeferOrder){
                  return;
                }
                this.$store.commit('order/setDeferOrderDate', null);
                this.$store.commit('order/setDeferOrderTime', null);
                component.$store.dispatch({
                    type: 'order/changeOrderType',
                    isDeferOrder: isDefer,
                }).then(() => {
                  component.calculateDiscount();
                });
            },
            afterChangeOrderType: function (){
              const component = this;
              if(component.isDeferOrder && (component.isAvailableClosestDelivery || component.isAvailableClosestPickup)){
                  component.calculateDiscount();
              }
            },
            setPizzeriaID(pizzeriaID){
                this.pizzeriaID = pizzeriaID;
            },
            selectStreet(street){
                this.street = street.title;
                this.deliveryAddress.street = street;
                this.stopSearch();
                this.endSearchStreet();
                this.$store.commit('order/setSaveAddress', true);
                this.$nextTick(() => this.$refs.house.focus());
            },
            stopSearch(){
                this.found_streets = [];
                this.finding = false;
            },
            searchStreet(){
                const phrase = this.street;
                if(phrase !== null && phrase.length >= 2){
                    this.finding = true;
                    const searchRegExp = new RegExp(phrase.toLowerCase()
                        .replaceAll("(", "")
                        .replaceAll(")", "")
                        .replaceAll(/\s/g, ".*"));
                    this.found_streets = this.streets.filter(street => {
                      if(street.title !== undefined){
                        return street.title.toLowerCase().search(searchRegExp) >= 0
                      }
                    }).sort(function(a, b) {
                      return a.title.toLowerCase().search(phrase.toLowerCase()) < b.title.toLowerCase().search(phrase.toLowerCase()) ? -1 : 1;
                    });
                }else {
                    this.stopSearch();
                    this.deliveryAddress.street = this.defaultStreet();
                }
            },
            defaultStreet(){
                return {ext_id:'', title:''};
            },
            loadStreet(pizzeriaId, cityCode){
                if(cityCode !== undefined && cityCode.length > 0) {
                    this.sendRequest('load-streets', {pizzeria_id: pizzeriaId, city_code: cityCode})
                        .then(response => {
                            this.processing = false;
                            const data = response.data;
                            if (data.status === 'success') {
                                this.streets = data.streets;
                            }
                        }).catch(error => {
                            console.log('Error', error.response);
                        });
                }
            },
            checkHouseField(){
              this.deliveryAddress.house = this.deliveryAddress.house.replace(/\D+/, '');
            },
            changeSaveAddress(){
              const saveAddress = !this.saveAddress;
              this.$store.commit('order/setSaveAddress', saveAddress);
            },
            chooseSavedAddress(address_id){
                const address = this.userInfo.addresses.find(address => address.id === address_id);
                if(address){
                  const street = address.address.street;
                  Object.assign(this.deliveryAddress, address.address);
                  this.street = street.title;
                  this.$store.commit('order/setSaveAddress', false);
                }else{
                  this.deliveryAddress = {street: this.defaultStreet()};
                  this.street = "";
                  this.$store.commit('order/setSaveAddress', true);
                }
            },
            startSearch(){
              this.startStreetSearch = true;
              this.$nextTick(() => this.$refs.street.focus());
            },
            endSearchStreet(){
                this.startStreetSearch = false;
            },
            leaveSearchStreetControl(){
              if(!this.finding){
                this.endSearchStreet();
              }
            },
            userAddresses: function (addresses, cityCode){
              return addresses.filter(address => { return address.address.street.ext_id !== undefined && address.city_code === cityCode;});
            },
            isClosePizzeriaPoint: function (pizzeriaPointId){
              return this.pizzeria.hand_close.points.filter(i => {return i.ID === pizzeriaPointId}).length > 0;
            },
            isClosePizzeriaPointForPickup: function (pizzeriaPointId){
              if(this.closeDeliveryOrderType || this.isDeferOrder){
                return false;
              }
              return this.isClosePizzeriaPointForPickupBase(pizzeriaPointId);
            },
            isClosePizzeriaPointForPickupBase: function (pizzeriaPointId){
              return ((this.closePickupOrderType || this.fullyCloseOrderType) && this.isClosePizzeriaPoint(pizzeriaPointId));
            },
            getFirstDelayOrderDay: function (dates){
              if(this.fullyCloseOrderTypeOnPizzeria){
                return dates[1];
              }

              if(this.isDelivery && !this.isAvailableClosestDelivery){
                return dates[1];
              }

              if(!this.isDelivery){
                if(!this.isAvailableClosestPickup){
                  return dates[1];
                }
                if(this.closePickupOrderType && this.isClosePizzeriaPoint(this.activePizzeriaPointId)){
                  return dates[1];
                }
              }

              return dates[0];
            },
            setOrderDateTime(value){
              if(value.date !== undefined) {
                this.$store.commit('order/setDeferOrderDate', value.date);
              }
              if(value.time !== undefined) {
                this.$store.commit('order/setDeferOrderTime', value.time);
              }
            }
        },
        mounted() {
            this.loadStreet(this.pizzeria.id, this.pizzeria.city_code);
            this.afterChangeDeliveryType(this.isDelivery);
        },
        mixins: [Utils, Checkout],
    }
</script>

<style lang="scss" scoped>
    .button-select-order-datetime{
        &.active {
          flex-direction: column;
          height: auto;
          align-items: center;

          .delivery-date-controller{
            display: flex;
            width: 100%;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
          }
        }
    }
</style>
